module.exports = __webpack_public_path__ + "img/damages.547b66ae.svg";